(function ($) {
  /*------| Document Ready Start |-----*/
  $(document).ready(function () {
    keypressNumberOnly();
    gmailvalidation();
    phoneValidation();
    copytext();
  });
  /*------| Document Ready End |-----*/



  /*------| Keypress Number Only Function Start |-----*/
  function keypressNumberOnly() {
    if ($('.numberOnly').length > 0) {
      $('.numberOnly').on('keypress', function (evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;

        // Allow only digits (0–9)
        if (charCode < 48 || charCode > 57) {
          evt.preventDefault();
        }
        // Prevent typing more than 10 digits
        if ($(this).val().length >= 10) {
          evt.preventDefault();
        }
      });

      // Also handle paste (prevent letters/symbols)
      $('.numberOnly').on('input', function () {
        this.value = this.value.replace(/\D/g, '').slice(0, 10);
      });
    }
  }
  /*------| Keypress Number Only Function End |-----*/



  /*------| Gmail Validation Function Start |-----*/
  function gmailvalidation() {
    if ($('.contact-page-box').length > 0) {
      function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
      }
      function showError($email) {
        $email.parent().find('.email-error').remove();
        $('<span class="email-error">Please enter a valid email address</span>')
          .appendTo($email.parent());
      }
      function clearError($email) {
        $email.parent().find('.email-error').remove();
      }
      jQuery(document).on('click', 'button[type="submit"], input[type="submit"]', function (e) {
        var $form = jQuery(this).closest('form');
        if (!$form.length) return;
        var $email = $form.find('[name="contact[email]"]');
        if (!$email.length) return;
        var emailVal = jQuery.trim($email.val());
        if (!isValidEmail(emailVal)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError($email);
          return false;
        }
      });
      jQuery(document).on('submit', 'form', function (e) {
        var $email = jQuery(this).find('[name="contact[email]"]');
        if (!$email.length) return;
        var emailVal = jQuery.trim($email.val());
        if (!isValidEmail(emailVal)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError($email);
          return false;
        }
      });
      jQuery(document).on('input', '[name="contact[email]"]', function () {
        clearError(jQuery(this));
      });
    }
  }
  /*------| Gmail Validation Function End |-----*/


  /*------| Copy text Function Start |-----*/
  function copytext() {
    if ($('.copy-text-area').length > 0) {
        function copyToClipboard(text) {
          if (navigator.clipboard) {
            navigator.clipboard.writeText(text);
          } else {
            var $temp = $('<textarea>');
            $('body').append($temp);
            $temp.val(text).select();
            document.execCommand('copy');
            $temp.remove();
          }
        }
        $(document).on('click', '.copy-text-area a', function (e) {
          e.preventDefault();
          var $this = $(this);
          var textToCopy = $.trim($this.text());
          copyToClipboard(textToCopy);
          $('.copy-tooltip').remove();
          var $tooltip = $('<span class="copy-tooltip">Copied</span>');
          $tooltip.css({
            position: 'absolute',
            background: '#000',
            color: '#fff',
            fontSize: '12px',
            padding: '4px 8px',
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            zIndex: 9999,
            opacity: 0
          });

          $('body').append($tooltip);
          var offset = $this.offset();
          $tooltip.css({
            top: offset.top - $tooltip.outerHeight() - 8,
            left: offset.left + ($this.outerWidth() / 2) - ($tooltip.outerWidth() / 2)
          });

          $tooltip.animate({ opacity: 1 }, 150);
          setTimeout(function () {
            $tooltip.fadeOut(200, function () {
              $(this).remove();
            });
          }, 1200);
        });
    }
  }
  /*------| Copy text Function End |-----*/


  /*------| Mobile Number Validation Function End |-----*/
    function phoneValidation() {
      if ($('.contact-page-box').length > 0) {
        function isValidPhone(phone) {
          return /^\d{10}$/.test(phone); // exactly 10 digits
        }

        jQuery(document).on('input', '[data-phone-validate="true"]', function () {
          this.value = this.value.replace(/\D/g, '').slice(0, 10);
          jQuery(this).parent().find('.phone-error').remove();
        });

        jQuery(document).on('click', 'button[type="submit"], input[type="submit"]', function (e) {

          var $form = jQuery(this).closest('form');
          if (!$form.length) return;

          var $phone = $form.find('[data-phone-validate="true"]');
          if (!$phone.length) return;

          var phoneVal = jQuery.trim($phone.val());

          if (!isValidPhone(phoneVal)) {
            e.preventDefault();
            e.stopImmediatePropagation();

            $phone.parent().find('.phone-error').remove();
            jQuery('<span class="phone-error">Please enter a valid 10-digit phone number</span>')
              .appendTo($phone.parent());

            return false;
          }
        });

        jQuery(document).on('submit', 'form', function (e) {

          var $phone = jQuery(this).find('[data-phone-validate="true"]');
          if (!$phone.length) return;

          var phoneVal = jQuery.trim($phone.val());

          if (!isValidPhone(phoneVal)) {
            e.preventDefault();
            e.stopImmediatePropagation();

            $phone.parent().find('.phone-error').remove();
            jQuery('<span class="phone-error">Please enter a valid 10-digit phone number</span>')
              .appendTo($phone.parent());

            return false;
          }
        });
      }
    }
  /*------| Mobile Number Validation Function End |-----*/


})(jQuery);